<div class="container" style="height: 100vh;">
    <h1 class="update_heading text-center"> UPLOAD DOCUMENTS AND REFERENCES </h1>

    <div class="row" style="display: flex; justify-content: space-between;">
        <div class="col-md-5 docs_shadow mt-2 p-3">
            <h2> Documents</h2>
            <p> Please upload a minimum of  2 documents to move forward with your onboarding.</p>
            <button class="btn doc_popup_btn"  data-toggle="modal" data-target="#documentModal">  Upload Documents </button>

            <div *ngFor="let doc of doc_data" style="margin-top: 20px;">
                <ul class="mt-2" type="square"  style="padding-left: 20px;">
                    <li class="ref_name" >{{ doc.type }} 
                        <span *ngIf="doc.status == 10" style="float: right; color: #3db44b; "> Successful &nbsp; <fa-icon [icon]="faCheckCircle" class="fa-lg" style="color: #3db44b;" > </fa-icon>  </span>
                        <span *ngIf="doc.status == 0" style="float: right; color: #eeb40c;"> Pending &nbsp; <fa-icon [icon]="faExclamationCircle" class="fa-lg" style="color: #F9E312;" ></fa-icon> </span>
                        <span *ngIf="doc.status == 1" style="float: right; color: coral;"> Rejected &nbsp; <fa-icon [icon]="faTimesCircle" class="fa-lg" style="color: coral;" ></fa-icon> </span>
                    </li>
                </ul>
            </div>
            <div class="notification_wrapper_pass" id="docPass">
                <p class="notification_pass">{{docUploadStatMsg}}</p>
            </div>
            <div class="notification_wrapper_fail" id="docFail">
                <p class="notification_fail">{{docUploadStatMsg}}</p>
            </div>
        </div>
        <div class="col-md-5 docs_shadow mt-2 p-3">
            <h2> References</h2>
            <p> Please upload a minimum of 2 references to move forward with your onboarding.</p>
            <button class="btn ref_popup_btn" [disabled]="isRefsDisabled" data-toggle="modal" data-target="#ref1Modal">Upload References  </button>    
            <div *ngFor="let ref of ref_data" style="margin-top: 20px;">
                <ul class="mt-2" type="square"  style="padding-left: 20px;">
                    <li class="ref_name">{{ ref.name }} 
                        <span *ngIf="ref.status == 2" style="float: right; color: #3db44b; "> Successful &nbsp; <fa-icon [icon]="faCheckCircle" class="fa-lg" style="color: #3db44b;" > </fa-icon>  </span>
                        <span *ngIf="ref.status == 0" style="float: right; color: #eeb40c;"> Pending &nbsp; <fa-icon [icon]="faExclamationCircle" class="fa-lg" style="color: #F9E312;" ></fa-icon> </span>
                        <span *ngIf="ref.status == 1" style="float: right; color: coral;"> Rejected &nbsp; <fa-icon [icon]="faTimesCircle" class="fa-lg" style="color: coral;" ></fa-icon> </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="ref1Modal" tabindex="-1" aria-labelledby="ref1ModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">
                    <div class="row refs_popup">
                        <div class="col-md-4 popup_left">
                            <div class="popup_icon">
                                <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                <p style="font-size: 20px; font-weight: 500;"> Add References </p>
                            </div>
                        </div>
                        <div class="col-md-8 popup_right">
                            <div class="popup_close_btn">
                                <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="float: right;" ></fa-icon>
                            </div>
                            <div>        
                                <h1 class="p-2 text-center"> Reference 1 </h1>
                                <form role="form"> 
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="name_1" placeholder="Reference Name 1" type="text" [ngModel]="ref1PopupAdd.name" (ngModelChange)="changeRef1Name($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="email_1" placeholder="Reference Email 1" type="text" [ngModel]="ref1PopupAdd.email" (ngModelChange)="changeRef1Email($event)" >
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="phone_1" placeholder="Reference Phone 1" type="text" [ngModel]="ref1PopupAdd.phone" (ngModelChange)="changeRef1Phone($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="address_1" placeholder="Reference Address 1" type="text" [ngModel]="ref1PopupAdd.address" (ngModelChange)="changeRef1Address($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="city_1" placeholder="Reference City 1" type="text" [ngModel]="ref1PopupAdd.city" (ngModelChange)="changeRef1City($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="state_1" placeholder="Reference State 1" type="text" [ngModel]="ref1PopupAdd.state" (ngModelChange)="changeRef1State($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="zip_1" placeholder="Reference Zip 1" type="text" [ngModel]="ref1PopupAdd.zip" (ngModelChange)="changeRef1Zip($event)">
                                    </div>
                                    <div class="reference_message" *ngIf="ref_msg == true">
                                        <p> {{ ref_msg_str }} </p>
                                    </div>
                                    <div class="col-md-12 ref_submit_btn">
                                        <button type="submit" class="btn btn-outline-warning" (click)="submitRef1()" > Submit </button>    
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="ref2Modal" tabindex="-1" aria-labelledby="ref2ModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">
                    <div class="row refs_popup">
                        <div class="col-md-4 popup_left">
                            <div class="popup_icon">
                                <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                <p style="font-size: 20px; font-weight: 500;"> Add References </p>
                            </div>
                        </div>
                        <div class="col-md-8 popup_right">
                            <div class="popup_close_btn">
                                <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="float: right;" ></fa-icon>
                            </div>
                            <div>        
                                <h1 class="p-2 text-center"> Reference 2 </h1>
                                <form class="p-2" role="form"> 
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="name_2" placeholder="Reference Name 2" type="text" [ngModel]="ref2PopupAdd.name" (ngModelChange)="changeRef2Name($event)" >
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="email_2" placeholder="Reference Email 2" type="text" [ngModel]="ref2PopupAdd.email" (ngModelChange)="changeRef2Email($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="phone_2" placeholder="Reference Phone 2" type="text" [ngModel]="ref2PopupAdd.phone" (ngModelChange)="changeRef2Phone($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="address_2" placeholder="Reference Address 2" type="text" [ngModel]="ref2PopupAdd.address" (ngModelChange)="changeRef2Address($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="city_2" placeholder="Reference City 2" type="text" [ngModel]="ref2PopupAdd.city" (ngModelChange)="changeRef2City($event)" >
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="state_2" placeholder="Reference State 2" type="text" [ngModel]="ref2PopupAdd.state" (ngModelChange)="changeRef2State($event)">
                                    </div>
                                    <div class="form-group col-md-12">
                                        <input class="form-control" name="zip_2" placeholder="Reference Zip 2" type="text" [ngModel]="ref2PopupAdd.zip" (ngModelChange)="changeRef2Zip($event)">
                                    </div>
                                    <div class="reference_message" *ngIf="ref_msg == true">
                                        <p> {{ ref_msg_str }} </p>
                                    </div>
                                    <div class="col-md-12 ref_submit_btn">
                                        <button type="submit" class="btn btn-outline-warning" (click)="submitRef2()" > Submit </button>    
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="documentModal" tabindex="-1" aria-labelledby="documentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">
                    <div class="row refs_popup">
                        <div class="col-md-4 popup_left">
                            <div class="popup_icon">
                                <img src="assets/images/pay-logo.png" style="width: 85px; margin: auto;">
                                <p style="font-size: 20px; font-weight: 500;"> Add Documents </p>
                            </div>
                        </div>
                        <div class="col-md-8 popup_right">
                            <div class="popup_close_btn">
                                <fa-icon id="closeModal" [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                            </div>
                            <div>        
                                <h1 class="p-3 text-center"> Add Document </h1>
                                <div>
                                    <form role="form">
                                        <div *ngIf="docInfo.length == 0 || (docInfo.length == 1 && docInfo.data[0].type !== 'adhar') ">
                                            <div class="form-group col-md-12">
                                                <ng-select (change)="onDocTypeChange($event)">
                                                    <ng-option *ngFor="let doc of docAdhar" [value]="doc.id">{{doc.name}}</ng-option>
                                                 </ng-select>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-12" *ngIf="docInfo.length > 0 && docInfo.data[0].type == 'adhar' ">
                                            <ng-select (change)="onDocTypeChange($event)">
                                                <ng-option *ngFor="let doc of docTypeSel" [value]="doc.id">{{doc.text}}</ng-option>
                                             </ng-select>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input  type="text" id="docnum" name="docnum" class="form-control" (change)="onDocNumChange($event)" placeholder=" Document Number"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input  type="text" id="docname" name="docname" class="form-control" (change)="onDocNameChange($event)" placeholder=" Name as per Adhar card"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input type="file" id="docupload" name="docupload" class="upload_box" (change)="onDocChange($event)" style="width: 100%;">
                                        </div>
                                        <div class="col-md-12 ref_submit_btn">
                                            <button type="submit" class="btn btn-outline-warning" (click)="uploadDocFile()" > Submit </button>    
                                        </div>
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

